import { Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import HotelDetailPage from './pages/HotelDetailPage';
import BookingFunnelPage from './pages/BookingFunnelPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import ListYourPropertyPage from './pages/ListYourPropertyPage';
import GuestAccountPage from './pages/GuestAccountPage';
import GuestLoginPage from './pages/GuestLoginPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import OurStoryPage from './pages/OurStoryPage';
import PressPage from './pages/PressPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

/**
 * BestAcco storefront — the public, guest-facing booking site.
 *
 * Routes here are the consumer journey from the BestAcco PRD:
 *   browse/search → hotel detail → book (pay at property) → guest account.
 * Property owners reach us via "List your property" (a leads form, not a portal).
 *
 * This app is intentionally separate from the PMS staff app (apps/web). It shares
 * the backend, never the UI, auth, or design system.
 */
export default function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/hotel/:id" element={<HotelDetailPage />} />
          <Route path="/book/:id" element={<BookingFunnelPage />} />
          <Route path="/booking/:ref" element={<BookingConfirmationPage />} />
          <Route path="/list-your-property" element={<ListYourPropertyPage />} />
          <Route path="/account/*" element={<GuestAccountPage />} />
          <Route path="/login" element={<GuestLoginPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/our-story" element={<OurStoryPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  );
}
